import { render, staticRenderFns } from "./HistoricDetail.vue?vue&type=template&id=fa9c756a"
import script from "./HistoricDetail.vue?vue&type=script&lang=js"
export * from "./HistoricDetail.vue?vue&type=script&lang=js"
import style1 from "./HistoricDetail.vue?vue&type=style&index=1&id=fa9c756a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports